import apiUseCases from "@src/cloud-connect/api";
import { postSupportCommentByTicketWithFiles } from "@src/cloud-connect/api/support/post-support-comment-by-ticket";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import {
  PostSupportCommentByTicketPayload,
  TicketCommentItem,
} from "@src/types/support";

export interface PostSupportCommentByTicketResult {
  success: boolean;
  data?: TicketCommentItem;
  error?: string;
}

export const postSupportCommentByTicketUseCase = async (
  ticketId: string,
  payload: PostSupportCommentByTicketPayload,
): Promise<PostSupportCommentByTicketResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    const response = await apiUseCases.postSupportCommentByTicket(
      namespace,
      ticketId,
      payload,
    );

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to post support comment by ticket.",
      ).message,
    };
  }
};

export const postSupportCommentByTicketWithFilesUseCase = async (
  ticketId: string | number,
  payload: PostSupportCommentByTicketPayload,
  files: File[],
): Promise<PostSupportCommentByTicketResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    const response = await postSupportCommentByTicketWithFiles(
      namespace,
      ticketId,
      payload,
      files,
    );

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to post support comment by ticket.",
      ).message,
    };
  }
};
